export default {
  trainer_survey_entries: []
}
